export var SECTION_EXTENSION_KEY = 'hub-section';
export var SECTION_EXTENSION_ANALYTICS_SOURCE = 'hub-sectionExtensionConfig';
export var CONTENT_WIDTH = /*#__PURE__*/function (CONTENT_WIDTH) {
  CONTENT_WIDTH["NARROW"] = "narrow";
  CONTENT_WIDTH["WIDE"] = "wide";
  CONTENT_WIDTH["FULL"] = "full";
  return CONTENT_WIDTH;
}({});
export var DEFAULT_CONTENT_WIDTH = CONTENT_WIDTH.WIDE;
export var DEFAULT_BACKGROUND_COLOR = "var(--ds-surface-overlay, #FFFFFF)";